import { z } from 'zod';
export const uuid = z.string().uuid();
export const email = z.string().trim().toLowerCase().email().max(254);
export const password = z.string().min(8).max(128);
/** Telefone em E.164 (+5511999999999). Normalização feita em utils/phone. */
export const phoneE164 = z.string().regex(/^\+[1-9]\d{7,14}$/, 'INVALID_PHONE');
export const timezone = z.string().min(3).max(64);
export const locale = z.enum(['pt-BR', 'en-US']);
export const isoDateTime = z.string().datetime({ offset: true });
export const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);
export const hhmm = z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/);
export const money = z.number().nonnegative().multipleOf(0.01);
export const cursorPagination = z.object({
    cursor: z.string().optional(),
    limit: z.coerce.number().int().min(1).max(100).default(25),
});
//# sourceMappingURL=common.js.map